// PWA utility functions

export const registerServiceWorker = () => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/sw.js")
          .then((registration) => {
            console.log("SW registered: ", registration)
  
            // Check for updates
            registration.addEventListener("updatefound", () => {
              const newWorker = registration.installing
              newWorker.addEventListener("statechange", () => {
                if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                  // New content is available, show update notification
                  showUpdateNotification()
                }
              })
            })
          })
          .catch((registrationError) => {
            console.log("SW registration failed: ", registrationError)
          })
      })
    }
  }
  
  export const showUpdateNotification = () => {
    if (window.confirm("A new version of AgroPlanner is available. Would you like to update?")) {
      window.location.reload()
    }
  }
  
  export const requestNotificationPermission = async () => {
    if ("Notification" in window) {
      const permission = await Notification.requestPermission()
      return permission === "granted"
    }
    return false
  }
  
  export const showNotification = (title, options = {}) => {
    if ("serviceWorker" in navigator && "Notification" in window) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification(title, {
          icon: "/icons/android-chrome-192x192.png",
          badge: "/icons/favicon-32x32.png",
          vibrate: [100, 50, 100],
          ...options,
        })
      })
    }
  }
  
  export const isStandalone = () => {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  }
  
  export const canInstall = () => {
    return !isStandalone() && "serviceWorker" in navigator
  }
  
  // Offline detection
  export const isOnline = () => navigator.onLine
  
  export const onNetworkChange = (callback) => {
    window.addEventListener("online", () => callback(true))
    window.addEventListener("offline", () => callback(false))
  }
  
  // Cache management
  export const clearAppCache = async () => {
    if ("caches" in window) {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
    }
  }
  
  export const getCacheSize = async () => {
    if ("caches" in window && "storage" in navigator && "estimate" in navigator.storage) {
      const estimate = await navigator.storage.estimate()
      return estimate.usage
    }
    return 0
  }
  